import { render, staticRenderFns } from "./ReportInformation.vue?vue&type=template&id=cba460f2&scoped=true&"
import script from "./ReportInformation.vue?vue&type=script&lang=js&"
export * from "./ReportInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba460f2",
  null
  
)

export default component.exports